import { Component, OnInit, Input, EventEmitter, Output, OnChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms'
import { SelectListService } from './services/select-list.service';
import { APIServices } from '../../../../config/app-config';
import { FormsService } from '../services/forms-service.service';
import {MatSelect} from '@angular/material/select';

@Component({
  selector: 'selectList',
  templateUrl: './select-list.component.html',
  styleUrls: ['./select-list.component.css']
})

export class SelectListComponent implements OnInit {

  private initFinish: boolean = false;
  private payConditions: boolean = false;
  public errorText: string;
  private isCleaner: boolean = false;
  public hideElement: boolean = false;
  @Input('FilterName') filterName: string;
  @Input('formName') formName: string;
  @Input('parent') parent: FormGroup;
  private _readonly: boolean;
  @Input('readonly')
  set setReadOnly(readonly: boolean) {
    this._readonly = readonly;
    if (readonly != null && this.parent != null) {
      if (!this.initFinish) {
        this.initFinish = true;
      }
      if (readonly) {
        this.parent.controls[this.formName].disable();
      } else {
        if (this._EnableName != null) {
          this.checkEnable();
        }
        else {
          this.parent.controls[this.formName].enable();
        }
      }
    }
  };

  @Input('ApiService') filter: string;
  @Input('EmptyOption') EmptyOption: boolean = true;

  @Input('AutoSelect') autoSelect: boolean = true;
  @Input('GetElements') getElements: boolean = true;
  @Input('Parameters') parameters = [];
  public _EnableName;
  @Input('enableName')
  set setEnableName(enableName: string) {
    this._EnableName = enableName;
    this.checkEnable();
  };
  private _HiddenName;
  @Input('hiddenName')
  set setHiddenName(hiddenName: string) {
    this._HiddenName = hiddenName;
    this.checkHidden();
  };
  filterList = null;
  value = null;

  @Output() selectEvent = new EventEmitter();
  @Output() finishLoad = new EventEmitter();

  
  @ViewChild("select") selectComponent: MatSelect;

  constructor(
    private service: SelectListService,
    private FormsService: FormsService
  ) {
    FormsService.EnableDisabledList$.subscribe(value => {
      this.checkEnable();
      this.checkHidden();
    });
  }

  ngOnInit() {
    this.initRequired();
    if (this.getElements) {
      this.getData();
    }
  }

  cleanInput() {
    this.parent.controls[this.formName].reset();
  }

  getData(filter = null) {
    switch (filter != null ? filter : this.filter) {
      case "UserServices":
        this.service.getSelectListData(APIServices.common.getUserServices, this.parameters)
          .toPromise()
          .then(result => {
            this.filterList = result;
            this.onLoadElements();
          });
        break;
      case "EmitterByServ":
        this.service.getSelectListData(APIServices.common.getEmitterByServ, this.parameters)
          .toPromise()
          .then(result => {
            this.filterList = result;
            this.onLoadElements();
          });
        break;
      case "GetConditionPay":
        this.payConditions = true;
        let urlPay = this.globalSearch(APIServices, filter != null ? filter : this.filter)
        if (urlPay != false) {
          this.service.getSelectListData(urlPay, this.parameters)
            .toPromise()
            .then(result => {
              this.filterList = result;
              this.onLoadElements();
            });
        }
        break;
      default:
        let url = this.globalSearch(APIServices, filter != null ? filter : this.filter)
        if (url != false) {
          this.service.getSelectListData(url, this.parameters)
            .toPromise()
            .then(result => {
              if (this.filterList == null || !this.Equals(this.filterList, result)) {
                this.filterList = result;
              }
              this.onLoadElements();
            });
        }
        break;
    }
  }

  Equals(array1, array2) {
    // if the other array is a falsy value, return
    if (!array2)
      return false;

    // compare lengths - can save a lot of time 
    if (array1.length != array2.length)
      return false;

    for (var i = 0, l = array1.length; i < l; i++) {
      if (array1[i].id != array2[i].id) {
        // Warning - two different object instances will never be equal: {x:20} != {x:20}
        return false;
      }
    }
    return true;
  }

  onLoadElements() {
    if (this.filterList != null && this.filterList.length == 1 && this.autoSelect) {
      this.parent.controls[this.formName].setValue(this.filterList[0]);
      this.elementSelected({ value: this.filterList[0] });
      this.parent.controls[this.formName].disable();
    }
    else if (this.filterList != null && this.autoSelect && this.value != null) {
      this.selectElementById(this.value);
      this.value = null;
      this.checkEnable();
    }
    else if (this.filterList != null && this.value != null) {
      this.selectElementById(this.value);
      this.checkEnable();
    }
    this.finishLoad.emit();
  }

  elementSelected(event) {
    this.selectEvent.emit(event.value);
    this.value = event.value != null ? event.value.id : null;
  }

  selectElementById(id) {
    if (this.filterList == null) {
      this.value = id;
    }
    else if (this.filterList.find(x => x.id == id) != null) {
      this.parent.controls[this.formName].reset();
      this.parent.controls[this.formName].setValue(this.filterList.find(x => x.id == id));
    }
    else {
      this.parent.controls[this.formName].reset();
    }
  }

  //Funcion to find url by name
  globalSearch(obj, value) {
    for (var p in obj)
      if (p == value) {
        return (obj[p]);
      } else if (typeof obj[p] == "object" && obj[p] != obj) {
        var te = this.globalSearch(obj[p], value);
        if (te != false) { return te }
      }
    return false;
  }

  checkEnable() {
    if(this.parent != undefined){
      if (this._EnableName != null && this.parent != null) {
        if (this.FormsService.ElementEnabled(this._EnableName) && this._readonly != true) {
          this.parent.controls[this.formName].enable();
          if (this.filterList != null && this.filterList.length == 1 && this.autoSelect) {
            this.parent.controls[this.formName].setValue(this.filterList[0]);
            this.elementSelected({ value: this.filterList[0] });
            this.parent.controls[this.formName].disable();
          }
        } else {
          this.parent.controls[this.formName].disable();
        }
      }
      else if(!this._readonly){
        this.parent.controls[this.formName].enable();
      }
    }
  }

  checkHidden() {
    if (this._HiddenName != null && this.parent != null) {
      if (this.FormsService.ElementHidden(this._HiddenName)) {
        this.hideElement = true;
      } else {
        this.hideElement = false;
      }
    }
  }

  initRequired() {
    this.errorText = "Campo obligatorio";
    if (this.parent.controls[this.formName].errors) {
      if (this.parent.controls[this.formName].errors.required) {
        this.filterName = this.filterName + "*";
      }
    } else if (this.parent.controls[this.formName].status == 'DISABLED' && this.parent.controls[this.formName].validator) {
      this.filterName = this.filterName + "*";
    }
  }

  trackByFn(index, item) {
    return item.id;
  }
}